export const authConstants = {
    SIGN_IN_SUCCESS:'SIGN_IN_SUCCESS',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGOUT: "LOGOUT"
};